export const pipelineGroupColor = '#38812f';
